<div class="content">
  <div class="preview-header">
    <button matButton="text" [disabled]="index <= 0" (click)="move(-1)">
      <mat-icon>chevron_left</mat-icon>
    </button>
    @if (getCurrentUnit()) {
      <span class="position">Unit {{ index + 1 }} of {{ units.length }} · Line {{ getCurrentUnit().lineId }}</span>
    }
    <button matButton="text" [disabled]="index >= units.length - 1" (click)="move(1)">
      <mat-icon>chevron_right</mat-icon>
    </button>
    <span class="jump">
      Line #
      <input type="text" [(ngModel)]="lineJump" (keyup.enter)="jumpToLine()" />
      <button matButton="text" (click)="jumpToLine()">Go</button>
    </span>
  </div>
  @if (getCurrentUnit()) {
    <div class="cards">
      @if (hasShippingTag()) {
        <div class="tag-card shipping">
          <div class="card-title">Shipping Tag</div>
          <div class="card-line">Location: {{ getCurrentUnit().location }}</div>
          <div class="card-line">Reference: {{ getCurrentUnit().reference }}</div>
          <div class="card-line">Model: {{ getCurrentUnit().partNumber }}</div>
          <div class="card-line">Serial: [assigned at ship]</div>
          <div class="card-footer">ClimateMaster · Tag {{ getCurrentUnit().tag || getCurrentUnit().sequence }}</div>
        </div>
      }
      @if (hasRiserTag()) {
        <div class="tag-card riser">
          <div class="card-title">Hi-Rise Riser Tag</div>
          <div class="card-line">Floor {{ getCurrentUnit().floor }}</div>
          <div class="card-line">Riser {{ getCurrentUnit().riser }}</div>
          <div class="card-line">Room {{ getCurrentUnit().room }}</div>
          <div class="card-footer">Cab ID# {{ getCurrentUnit().sequence }} · Riser: {{ getCurrentUnit().riser }}</div>
        </div>
      }
      @if (!hasShippingTag() && !hasRiserTag()) {
        <div class="empty">No tag data entered for this unit yet.</div>
      }
    </div>
  }
  <div class="preview-actions">
    <div class="disclaimer">This preview is a close approximation of the actual shipping and vhs tag and may not exactly match the printed result.</div>
    <span class="spacer"></span>
    <button class="accent-button" matButton="elevated" (click)="close()">Close</button>
  </div>
</div>
